class APIS {
	apis() {
		return {
			systemPermissionsFetchAll: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/system-permission/all'
			},
			systemPermissionsFetchDecorated: {
				headers: {
					'xt-user-token': null
				},
				method: 'get',
				path: '/system-permission/decorated'
			},
			systemPermissionsCreate: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/system-permission/add'
			},
			systemPermissionsUpdate: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/system-permission/update'
			},
			systemPermissionsDelete: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/system-permission/delete'
			},
		};
	}
}

export default new APIS();
